import React from "react";
import { SectionCta } from "../SectionCta";
import { situations, stabilityFactors } from "../../data/content";
export function Situations() {
  return <section className="bg-cream px-4 py-16 sm:px-6 sm:py-24" aria-labelledby="situations-title" data-id="element-277" data-mp="2y8f5f1pzp8jl">
      <div className="mx-auto max-w-3xl text-center" data-id="element-278" data-mp="2tdhlv0v33gsg">
        <p className="text-sm font-bold uppercase tracking-wide text-brand" data-id="element-279" data-mp="2ofg5wosyfxl7">Does this sound familiar?</p>
        <h2 id="situations-title" className="mt-3 font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-280" data-mp="2jiha81tn7ikw">
          6 Situations Every Denture-Focused Dental Professional Will Recognize
        </h2>
      </div>

      <ol className="mx-auto mt-12 grid max-w-6xl gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-3" data-id="element-281" data-mp="2agzz6xv3e732">
        {situations.map((s, i) => <li key={s.title} className="flex flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-navy-900/5" data-id="element-282" data-mp="8p3eoyqy5mw5" data-mpi={i}>
            <span className="font-display text-4xl font-black leading-none text-gold-500" data-id="element-283" data-mp="3pqoq54s3zpc">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="mt-3 font-display text-lg font-extrabold uppercase leading-snug text-ink" data-id="element-284" data-mp="1377ps745atdg">{s.title}</h3>
            <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-285" data-mp="u4ewxzfbe9li">{s.body}</p>
          </li>)}
      </ol>

      <div className="mx-auto mt-14 max-w-4xl overflow-hidden rounded-3xl bg-navy-900 text-white" data-id="element-286" data-mp="z38eq41mwmrh">
        <div className="p-6 sm:p-10" data-id="element-287" data-mp="1mskhom6dbylc">
          <p className="text-base font-semibold text-gold-400" data-id="element-288" data-mp="1mtm5zsceahl0">Here's what I want you to understand:</p>
          <p className="mt-3 font-display text-2xl font-black leading-tight sm:text-3xl" data-id="element-289" data-mp="1qu63ix0vrn7o">
            A moving mandibular denture is a clinical finding — not a complete diagnosis.
          </p>
          <p className="mt-5 text-base text-white/80" data-id="element-290" data-mp="1i0t194gxf98x">Poor stability may involve several interacting factors:</p>
          <ul className="mt-4 flex flex-wrap gap-2" data-id="element-291" data-mp="25qnehn55qztp">
            {stabilityFactors.map(f => <li key={f} className="rounded-full bg-white/10 px-4 py-2 text-sm font-semibold ring-1 ring-white/15" data-id="element-292" data-mp="2ajzpuvktta4i">
                {f}
              </li>)}
          </ul>
          <p className="mt-6 text-base text-white/85" data-id="element-293" data-mp="2fgvjmd1ma2ek">
            The key is understanding how to evaluate these factors <strong className="text-white" data-id="element-294" data-mp="2aemr1hsnp2cz">together</strong>.
            That's the purpose of the Mandibular Complete Denture Blueprint™.
          </p>
        </div>
      </div>

      <SectionCta label="Discover the complete clinical blueprint" data-id="element-295" data-mp="21guj4yp9kwzm" />
    </section>;
}